import type { ComponentProps } from 'react';
import React from 'react';

import { useTrackEventEffect } from '@order/Telemetry';

import { useHasLoggedOut } from '../../../context/AuthMachine';
import { SignedOutView } from '../../SignedOutView';

export const AccountSignedOutMessage = (props: ComponentProps<typeof SignedOutView>) => {
  const hasLoggedOut = useHasLoggedOut();

  useTrackEventEffect({ name: 'account.logged_out_view', skip: hasLoggedOut });

  return <SignedOutView {...props} />;
};
